import {
  ExtranetShopProductFamily,
  GetExtranetShopProductsQueryDto,
} from '@pharmac-extranet/extranet-api'
import { cleanQueryParams } from '../../../features/infinite-query/util/cleanQueryParams'

type TProductFamily = ExtranetShopProductFamily

export const mapShopProductSearchParamsToQueryParams = (
  searchParams: URLSearchParams
): GetExtranetShopProductsQueryDto => {
  const parsedParams = {
    search: searchParams.get('search') ?? undefined,
    productFamily: (searchParams.getAll('productFamily').length > 0
      ? searchParams.getAll('productFamily')
      : undefined) as undefined | TProductFamily,
    productGroupId: searchParams.get('productGroupId') ?? undefined,
    publishDateRangeStart: searchParams.get('publishDateRangeStart') ?? undefined,
    publishDateRangeEnd: searchParams.get('publishDateRangeEnd') ?? undefined,
    tagIds:
      searchParams.getAll('tagIds').length > 0
        ? searchParams.getAll('tagIds').map(Number)
        : undefined,
    freeOrPaidProduct: searchParams.get('freeOrPaidProduct') ?? undefined,
    filterByLanguage: searchParams.get('filterByLanguage') ?? undefined,
    sortKey: searchParams.get('sortKey') ?? undefined,
    sortOrder: searchParams.get('sortOrder') ?? undefined,
  }

  return cleanQueryParams(parsedParams)
}
